// src/GrowthBookProvider.tsx
import {
  GrowthBook,
  GrowthBookProvider as Provider
} from "@growthbook/growthbook-react";
import { countryCheckTranslations } from "@repo/core-api";
import { EnvConfig } from "@repo/env-config";
import { storageService } from "@repo/storage";
import { detectBrowser, TEN_SECONDS } from "@repo/utils";
import mixpanel from "mixpanel-browser";
import { useEffect } from "react";
import { jsx } from "react/jsx-runtime";
var GROWTHBOOK_EXPERIMENT_EVENT = "growthbook_experiment";
var generateId = () => {
  const randomAlphanumeric = Math.random().toString(36).substring(2, 15);
  const timestamp = Date.now().toString(36);
  return randomAlphanumeric + timestamp;
};
var getOrCreateBrowserId = () => {
  if (typeof window === "undefined") return "server";
  let growthbookBrowserId = storageService.getValue("growthbookBrowserId");
  if (!growthbookBrowserId) {
    growthbookBrowserId = generateId();
    storageService.setValue("growthbookBrowserId", growthbookBrowserId);
  }
  return growthbookBrowserId;
};
var growthbook = new GrowthBook({
  apiHost: EnvConfig.GATSBY_GROWTHBOOK_URL,
  clientKey: EnvConfig.GATSBY_GROWTHBOOK_KEY,
  enableDevMode: EnvConfig.GATSBY_ENV !== "prod",
  trackingCallback: (experiment, result) => {
    if (experiment && result) {
      const properties = {
        experiment: experiment.key,
        featureId: result.featureId,
        experiment_group: result.name
      };
      const extendedProperties = {
        ...properties,
        env: process.env.GATSBY_MIXPANEL_ENV
      };
      if (mixpanel) {
        mixpanel.track(GROWTHBOOK_EXPERIMENT_EVENT, extendedProperties);
      }
      if (typeof window !== "undefined") {
        window.dataLayer.push({
          event: GROWTHBOOK_EXPERIMENT_EVENT,
          ...properties
        });
      }
    }
  }
});
growthbook.init({
  streaming: true,
  timeout: TEN_SECONDS,
  skipCache: true
});
var GrowthBookProvider = ({
  children
}) => {
  const load = async () => {
    const response = await countryCheckTranslations();
    const country = response?.data?.name || "unknown";
    growthbook.setAttributes({
      id: getOrCreateBrowserId(),
      browser: detectBrowser(),
      pathname: window.location.pathname,
      url: window.location.href,
      userAgent: navigator.userAgent,
      country
    });
  };
  useEffect(() => {
    load();
  }, []);
  const GrowthBookProviderComponent = Provider;
  return /* @__PURE__ */ jsx(GrowthBookProviderComponent, { growthbook, children });
};
export {
  GrowthBookProvider,
  growthbook
};
